// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__36zU2","label":"LabeledBox_label__2h6PY"};